import {Injectable} from "@angular/core";
import {LoaderService} from "./loader.service";
import {Observable} from "rxjs/Observable";
import {Response} from "@angular/http";

@Injectable()
export class HttpService extends LoaderService {
  public post(url: string, data?: any): Observable<Response> {
    return this.sendPost(url, data);

  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/http.service.ts